import React from "react";
import Header from "./components/Header";
import About from "./components/About";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Projects from "./components/Projects";
import Contact from "./components/Contact";

// Home page
export const HomePage: React.FC = () => (
  <main className="container mx-auto max-w-screen-md p-1 pt-20">
    <Header />
    <About />
    <Contact />
  </main>
);

// Experience & Education page
export const ExperienceEducationPage: React.FC = () => (
  <main className="container mx-auto max-w-screen-md p-1 pt-20">
    <Experience />
    <Education />
    <Projects />
  </main>
);
